module.exports = __webpack_public_path__ + "static/media/icon-beauty-full.9690f5a9.png";